import React from 'react'
import useSWR from 'swr'
import {get} from 'lodash-es'
import {Badge, Text, Skeleton} from '@chakra-ui/react'
import {useRails} from '../../../../contexts/rails'
import {fetcher} from '../../../../../api'
import {camelizeResult, dineroMoneyObjects} from '../../../../../api/serializer'
import {NextScreenHeader} from '../../../../components/ScreenHeader'

const Header = () => {
  const {organisation} = useRails()
  const {data, isLoading} = useSWR(
    `/api/suppliers/${organisation.currentSupplier.id}/unpaid_invoices_summary`,
    fetcher,
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      use: [camelizeResult, dineroMoneyObjects],
    },
  )

  return (
    <NextScreenHeader text="Cash-in" h="88px">
      <Skeleton
        isLoaded={!isLoading}
        fontSize="lg"
        display="flex"
        alignItems="center"
      >
        <Text textStyle="body-copy" color="grey.700" mx="sm" my="auto">
          Total unpaid
        </Text>
        <Badge textStyle="body-copy" bg="grey.100" borderRadius="sm" my="auto">
          {get(data, 'totalCount')}
        </Badge>
        <Text
          textStyle="body-copy-medium"
          fontWeight="700"
          mx="sm"
          my="auto"
          className="fs-mask"
        >
          {get(data, 'totalAmount')?.toFormat('$0,0')}
        </Text>
      </Skeleton>
    </NextScreenHeader>
  )
}

export default Header
